<template>
  <BaseTag
    v-bind="$attrs"
    v-on="$listeners"
    :styleConfig="styleConfig"
  >
    <template v-slot:text>
      <slot />
    </template>
    <template v-slot:controller>
      <GoogleMaterialIconPrimary
        v-if="enableClose"
        :color="iconColor"
        :content="'close'"
        :fontSize="fontSize"
        @mousedown="$emit('close')"
        :style="style.icon"
      />
    </template>
  </BaseTag>
</template>

<script>
  import BaseTag from '@base/v2/base-tag'
  import GoogleMaterialIconPrimary from '@modules/v2/icon/google-material-icon-primary'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'TagPrimary',
    inheritAttrs: false,
    components: {
      BaseTag,
      GoogleMaterialIconPrimary,
    },
    props: {
      enableClose: {
        type: Boolean,
        reuqired: false,
        default: false,
      },
    },
    data: function () {
      return {
        fontSize: '12px',
        style: {
          icon: {
            alignItems: 'center',
            cursor: 'pointer',
            display: 'flex',
            margin: `0 0 0 ${Layout.space.xs}`,
          },
        },
        styleConfig: {
          container: {
            borderRadius: Layout.space.xs,
            height: '19px',
            padding: `2px ${Layout.space.sm}`,
          },
          controller: {},
          root: {},
          state: {},
          text: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.sm,
            fontWeight: FontStyle.weight.lg,
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.style.icon,
        {
          color: this.color.dark5(),
        },
      );

      Object.assign(
        this.styleConfig.container,
        {
          backgroundColor: this.color.dark3(),
        }
      );
      Object.assign(
        this.styleConfig.text,
        {
          color: this.color.light1(),
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      iconColor: function () {
        return this.color.dark5();
      },
    },
  };
</script>
